import React from "react";
import "../../styles.css";
import { useAccessibility } from "../../../../../Store/contexts/AccessibilityContext";
import DefaultText from "../../../../../components/Accessibility/DefaultText";
import DefaultTextBold from "../../../../../components/Accessibility/DefaultTextBold";
import dayjs from "dayjs";
import "dayjs/locale/pt-br";
import moment from "moment";
import { Horarios } from "../../../../../interfaces/entities/Horarios";
import Calendar from "../../../../../components/Calendar/Calendar";
import DefaultButton from "../../../../../components/Accessibility/DefaultButton";
import { Radio, useMediaQuery } from "@mui/material";
import { getDayNameExtenso } from "../../../../../utils/DateFormat";
import { GestaoDeCronicosStepsEnum } from "../../../../../interfaces/enum/GestaoDeCronicosEnum";
import { useGestaoDeCronicosCaptacao } from "../../context/CaptacaoContext";
import LoadingApp from "../../../../../components/LoadingApp";

dayjs.locale("pt-br");

export const AgendarConsulta = () => {
  const { textStyleAccessibility, contrastColorAccessibility } =
    useAccessibility();
  const {
    loading,
    datesAvailable,
    hoursOptions,
    hourSelected,
    handleChangeStep,
    handleDate,
    handleMonth,
    setHourSelected,
    dateSelected,
  } = useGestaoDeCronicosCaptacao();
  const mobileScreen = useMediaQuery("(max-width: 899px)");

  const getHorarioCode = (h: Horarios) => {
    return `${h.data} ${h.hora}`;
  };

  return (
    <div className="content-container">
      <LoadingApp showLoading={loading} />

      {!loading && (
        <>
          <h1
            className="gestao-de-cronicos-title"
            style={textStyleAccessibility}
          >
            Agendar consulta
          </h1>
          <DefaultText
            text={
              "Analisamos suas respostas e gostaríamos de conhecer um pouco mais sobre a sua saúde."
            }
          />
          <DefaultText
            text={
              "Escolha o melhor dia e horário para você, e a nossa equipe de saúde irá entrar em contato por telefone para fazer mais algumas perguntas e concluir a sua avaliação."
            }
          />
          <div className="calendar-container">
            <div>
              <div className="calendar-title">
                <DefaultTextBold text="Selecione uma data no calendário" />
              </div>
              <div>
                <Calendar
                  handleDate={handleDate}
                  handleMonth={handleMonth}
                  daysList={datesAvailable.map((h) => h.data)}
                  selectedDate={null}
                />
              </div>
            </div>

            {dateSelected && (
              <>
                {!mobileScreen && (
                  <div className="select-hours-container">
                    <svg
                      width="28"
                      height="17"
                      viewBox="0 0 28 17"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12.3524 9.00466C12.6586 8.72975 12.6586 8.27156 12.3524 7.99664L5.75122 2.04017C5.41095 1.76526 4.90056 1.76526 4.59432 2.04017L3.81171 2.74273C3.50547 3.01764 3.50547 3.47583 3.81171 3.78129L9.05179 8.48538L3.81171 13.22C3.50547 13.5255 3.50547 13.9837 3.81171 14.2586L4.59432 14.9611C4.90056 15.236 5.41095 15.236 5.75122 14.9611L12.3524 9.00466Z"
                        fill="#383838"
                      />
                      <path
                        d="M24.3524 9.00466C24.6586 8.72975 24.6586 8.27156 24.3524 7.99664L17.7512 2.04017C17.411 1.76526 16.9006 1.76526 16.5943 2.04017L15.8117 2.74273C15.5055 3.01764 15.5055 3.47583 15.8117 3.78129L21.0518 8.48538L15.8117 13.22C15.5055 13.5255 15.5055 13.9837 15.8117 14.2586L16.5943 14.9611C16.9006 15.236 17.411 15.236 17.7512 14.9611L24.3524 9.00466Z"
                        fill="#383838"
                      />
                    </svg>
                  </div>
                )}
                <div className="select-hours">
                  <div>
                    <div className="calendar-title">
                      <DefaultTextBold text={"Horários disponíveis"} />
                    </div>
                    <div className="hours-container">
                      <DefaultTextBold text="Selecione o horário para agendamento" />
                      {hoursOptions.map((h) => (
                        <div key={getHorarioCode(h)} className="flex-row">
                          <Radio
                            style={contrastColorAccessibility}
                            checked={hourSelected === getHorarioCode(h)}
                            onChange={(_) => {
                              setHourSelected(getHorarioCode(h));
                            }}
                          />
                          <DefaultText
                            text={`${h.data} (${getDayNameExtenso(
                              moment(h.data, "DD/MM/YYYY").day()
                            )}) - ${h.hora}`}
                          />
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
          <DefaultButton
            className="button-questionnaire-detail"
            text="Continuar"
            disabled={hourSelected === "" || hoursOptions.length === 0}
            onClick={() => {
              handleChangeStep(
                GestaoDeCronicosStepsEnum.agendarConsultaConfirmeSeusDados
              );
            }}
          />
        </>
      )}
    </div>
  );
};
